module.exports = __webpack_public_path__ + "static/media/kg.28554a61.svg";